import React from "react";
import {
  Bath,
  UtensilsCrossed,
  Home as HomeIcon,
  PaintRoller,
  Layers,
  Square,
  Package,
  Grid3x3,
  Droplets,
  PenTool,
  Building2,
  HardHat,
} from "lucide-react";

export const serviceIcons = [
  Bath,
  UtensilsCrossed,
  HomeIcon,
  PaintRoller,
  Layers,
  Square,
  Package,
  Grid3x3,
  Droplets,
  PenTool,
  Building2,
  HardHat,
];

export const ServiceIcon = ({ index, className = "" }) => {
  const Icon = serviceIcons[index] || HomeIcon;
  return <Icon className={className} strokeWidth={1.2} />;
};
